import React from 'react';
import PropTypes from 'prop-types';
import Message, {getMessage} from '../common/Message';
import Input from 'epic-diesel-form/src/components/form/Input';
import getInfluencersFlowSchema from '../../data/InfluencersFlowSchema';
import styles from './Paypal.pcss';

export default class Paypal extends React.Component {
    static propTypes = {
        messages: PropTypes.object.isRequired,
        form: PropTypes.object,
        trigger: PropTypes.func,
        disabled: PropTypes.bool
    };

    onChange = event => {
        const {name, value} = event.target;
        this.props.trigger(name, value);
    };

    render() {
        const {messages, form, disabled} = this.props;
        const payoutInfoSchema = getInfluencersFlowSchema(getMessage, messages).payoutInfo;
        return (
            <div className={styles.section}>
                <div className={styles.title}>
                    <Message code="epic.affiliate.settings.paypal_title" />
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            id={payoutInfoSchema.payPal.identifier}
                            name={payoutInfoSchema.payPal.identifier}
                            type="email"
                            value={form.accountEmail || ''}
                            text={payoutInfoSchema.payPal.display.text}
                            fieldRequirement="require"
                            placeholder={payoutInfoSchema.payPal.display.text}
                            elementWrapperClassName="col-sm-12"
                            rowClassName="col-sm-6"
                            validations={payoutInfoSchema.payPal.validations}
                            validationErrors={payoutInfoSchema.payPal.validationMessages}
                            disabled={disabled}
                            onChange={this.onChange}
                            required
                        />
                    </div>
                </div>
            </div>
        );
    }
}
